import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import UniversityOfMadrasDetails from './section-components/university-of-madras-details';
import Footer from './global-components/footer-v2';
import {Helmet} from "react-helmet";

const UniversityOfMadras = () => {
    return <div>
        <Navbar />
        <Helmet>
            <title>Best Distance Education Courses by University Of Madras at MIET</title>
            <meta name="description" content="MIET Education offers the best distance education courses in India. Get your degree from the University of Madras and become a better professional." />
        </Helmet>
        <PageHeader headertitle="University of Madras"  />
        <UniversityOfMadrasDetails />
        <Footer />
    </div>
}

export default UniversityOfMadras

